import { triggerAnalyticsEvent } from 'syf-js-utilities';
const triggerPaymentSecurityAnalytics = (params) => triggerAnalyticsEvent({
    pageFunction: 'payment security',
    pageKind: 'account services',
    ...params
});
export default triggerPaymentSecurityAnalytics;
